namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

	export interface IDiagnosisSession {
        ids: number[];
        codes: string[];
		delimitedCodes: string;

		mapToEnterpriseCoordinatorDiagnosisSessionModel(): psgm.EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel;
	}

	export class DiagnosisSession implements IDiagnosisSession {
        ids: number[];
        codes: string[];
        delimitedCodes: string;

		constructor(obj?: IDiagnosisSession) {
            this.ids = [];
            this.codes = [];
            this.delimitedCodes = null;

            if (obj) {
                this.ids = obj.ids;
                this.codes = obj.codes;
				this.delimitedCodes = obj.delimitedCodes;
            }
        }

		mapToEnterpriseCoordinatorDiagnosisSessionModel(): psgm.EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel {
			return {
				diagnosisIds: this.ids,
				diagnosisCodes: this.codes,
				delimitedCodes: this.delimitedCodes
			}
		}
	}
}
